import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=0d3fbbd7&scoped=true&"
import script from "./Business.vue?vue&type=script&lang=js&"
export * from "./Business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3fbbd7",
  null
  
)

export default component.exports